import { useForm } from "@refinedev/antd";
import { useGetIdentity, useGetToPath } from "@refinedev/core";
import { Form, InputNumber, Modal, Select, Typography } from "antd";
import { authProvider } from "authProvider";
import { useState } from "react";
import { User } from "types/props";

export const AddCreditsForUserModal: React.FC<{
  users: User[];
  onClose: () => void;
  onSuccess?: () => void;
}> = ({ users, onClose, onSuccess }) => {
  const { refetch: refetchUser } = useGetIdentity<User>();
  const [creditType, setCreditType] = useState<"freeCredits" | "credits">("freeCredits");

  const { formProps, onFinish, saveButtonProps } = useForm({
    resource: "user/add-credits",
    action: "create",
    errorNotification: {
      type: "error",
      message: "Failed to add credit"
    },
    successNotification(data, values, resource) {
      return {
        key: "success-credit",
        type: "success",
        message: "Credits added successfully",
        description: "Update successful"
      };
    },
    onMutationSuccess(data, variables, context, isAutoSave) {
      authProvider
        .check()
        .then(() => {
          refetchUser();
        })
        .catch();
      onSuccess?.();
      onClose();
    }
  });

  return (
    <Modal
      open
      title={
        <Typography.Title level={5} style={{ backgroundColor: "#202440" }}>
          Add Credits
        </Typography.Title>
      }
      okType="default"
      cancelButtonProps={{
        type: "primary"
      }}
      okText={"Add Credits"}
      okButtonProps={saveButtonProps}
      onCancel={onClose}>
      <Form
        layout="vertical"
        {...formProps}
        onFinish={(values) => {
          onFinish({ ...values, creditType });
        }}>
        <Form.Item
          label={"Users"}
          name={"userIds"}
          required={false}
          rules={[
            {
              required: true
            }
          ]}>
          <Select
            style={{ width: "100%" }}
            allowClear
            mode="multiple"
            options={users.map((user) => ({
              value: user.id,
              label: user.email
            }))}
            optionFilterProp="label"
          />
        </Form.Item>
        <Form.Item
          label={"Credits"}
          name={"credits"}
          required={false}
          rules={[
            {
              transform(value) {
                return value !== undefined || value !== null ? Number(value) : undefined;
              },
              required: true,
              type: "number",
              max: 500,
              min: 1
            }
          ]}>
          <InputNumber
            precision={0}
            addonBefore={
              <Select
                style={{ width: 150 }}
                defaultValue={"freeCredits"}
                value={creditType}
                onChange={setCreditType}
                options={[
                  {
                    value: "freeCredits",
                    label: "Free Credits"
                  },
                  {
                    value: "credits",
                    label: "Purchased Credits"
                  }
                ]}
              />
            }
            controls={false}
            style={{ width: "100%" }}
            placeholder="100"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
